module.exports = __webpack_public_path__ + "static/img/FuZhuang_Banner_spring.ef517d95.jpg";